module.exports = __webpack_public_path__ + "media/ding.65001b24.wav";